module.exports = require("bluebird/js/main/captured_trace")();
